<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <ListPageShell>
    <template #header>
      <div class="list-page-panel is-header-minimal">
        <div class="list-page-heading">
          <div class="list-page-heading-main">
            <h1 class="list-page-title">分账规则管理</h1>
            <p class="list-page-description">配置和管理分账规则</p>
          </div>
        </div>
      </div>
    </template>

    <template #filters>
      <PageFilterBar
      :show-refresh="true"
      :refresh-loading="loading"
      @refresh="fetchRules"
    >
        <div class="w-48">
          <label class="block text-sm font-medium text-slate-700 mb-1">规则类型</label>
          <select
            v-model="searchForm.ruleType"
            class="form-select-native form-control-sm w-full"
          >
            <option value="">全部类型</option>
            <option v-for="t in ruleTypes" :key="t.value" :value="t.value">{{ t.label }}</option>
          </select>
        </div>
        <div class="w-40">
          <label class="block text-sm font-medium text-slate-700 mb-1">状态</label>
          <select
            v-model="searchForm.status"
            class="form-select-native form-control-sm w-full"
          >
            <option value="">全部状态</option>
            <option :value="1">启用</option>
            <option :value="0">停用</option>
          </select>
        </div>
      <template #searchActions>
        <button type="button" class="btn-primary inline-flex items-center gap-1" @click="handleSearch">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
            </svg>
            搜索
          </button>
        <button type="button" class="btn-secondary" @click="resetSearch">重置</button>
      </template>
      </PageFilterBar>
    </template>

    <div class="action-toolbar">
      <button class="btn-primary" @click="goToCreate">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          新增规则
      </button>
    </div>

    <div class="list-page-table-panel">
      <div class="data-table-shell">
        <div class="data-table-scroll">
          <table class="data-table text-sm">
            <thead class="data-table-head">
              <tr>
                <th class="data-table-th text-left">规则名称</th>
                <th class="data-table-th text-left">规则类型</th>
                <th class="data-table-th text-left">产品</th>
                <th class="data-table-th text-left">加盟商</th>
                <th class="data-table-th text-left">优先级</th>
                <th class="data-table-th text-left">状态</th>
                <th class="data-table-th text-left">创建时间</th>
                <th class="data-table-th text-center w-48">操作</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="loading">
                <tr v-for="n in 5" :key="n" class="animate-pulse">
                  <td class="data-table-td"><div class="h-4 w-32 bg-slate-200 rounded"/></td>
                  <td class="data-table-td is-center"><div class="h-6 w-20 bg-slate-200 rounded-full"/></td>
                  <td class="data-table-td"><div class="h-4 w-20 bg-slate-200 rounded"/></td>
                  <td class="data-table-td"><div class="h-4 w-20 bg-slate-200 rounded"/></td>
                  <td class="data-table-td"><div class="h-4 w-12 bg-slate-200 rounded"/></td>
                  <td class="data-table-td is-center"><div class="h-6 w-16 bg-slate-200 rounded-full"/></td>
                  <td class="data-table-td"><div class="h-4 w-24 bg-slate-200 rounded"/></td>
                  <td class="data-table-td is-center"><div class="h-8 w-20 bg-slate-200 rounded"/></td>
                </tr>
              </template>
              <tr v-if="!loading && ruleList.length === 0">
                <td colspan="8" class="data-table-empty">
                  <div class="flex flex-col items-center">
                    <svg class="w-12 h-12 text-slate-300 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                    <span>暂无分账规则</span>
                    <button class="mt-3 text-primary-600 hover:text-primary-700 text-sm" @click="goToCreate">新建规则</button>
                  </div>
                </td>
              </tr>
              <tr v-for="rule in ruleList" :key="rule.id" class="data-table-row">
                <td class="data-table-td">
                  <div class="flex items-center gap-2">
                    <span class="text-sm font-medium text-slate-900">{{ rule.ruleName }}</span>
                  </div>
                </td>
                <td class="data-table-td">
                  <span class="px-2 py-1 bg-slate-100 text-slate-700 rounded text-xs">{{ getTypeLabel(rule.ruleType) }}</span>
                </td>
                <td class="data-table-td">
                  <span class="text-sm text-slate-600">{{ rule.productName || '-' }}</span>
                </td>
                <td class="data-table-td">
                  <span class="text-sm text-slate-600">{{ rule.franchiseeName || '-' }}</span>
                </td>
                <td class="data-table-td">
                  <div class="flex items-center gap-1">
                    <span class="text-sm text-slate-900">{{ rule.priority }}</span>
                    <div class="flex flex-col">
                      <button class="p-0.5 text-slate-400 hover:text-primary-600" @click="changePriority(rule, 1)">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
                        </svg>
                      </button>
                      <button class="p-0.5 text-slate-400 hover:text-primary-600" @click="changePriority(rule, -1)">
                        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </td>
                <td class="data-table-td">
                  <span
                    class="status-badge"
                    :class="rule.status === 1 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                  >
                    <span class="w-1.5 h-1.5 rounded-full mr-1" :class="rule.status === 1 ? 'bg-green-500' : 'bg-red-500'"/>
                    {{ rule.status === 1 ? '启用' : '停用' }}
                  </span>
                </td>
                <td class="data-table-td text-slate-600">{{ rule.createTime || '-' }}</td>
                <td class="data-table-td is-center">
                  <div class="flex items-center justify-center gap-1">
                    <button class="table-action-button is-primary" title="编辑" @click="goToEdit(rule)">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                      </svg>
                    </button>
                    <button class="table-action-button is-danger" title="删除" @click="deleteRule(rule)">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <AppPagination
        v-if="pagination.total > 0"
        class="pagination-bridge"
        :pagination="pagination"
        :page-sizes="[10, 20, 50]"
        @page-change="handlePageChange"
        @size-change="handlePageSizeChange"
      />
    </div>

    <!-- 删除确认弹窗 -->
    <div v-if="showDeleteModal" class="fixed inset-0 z-50 flex items-center justify-center">
      <div class="absolute inset-0 bg-black/50" @click="closeDeleteModal"/>
      <div class="relative bg-white rounded-xl shadow-xl w-full max-w-sm mx-4">
        <div class="p-6 text-center">
          <div class="w-12 h-12 mx-auto mb-4 text-red-500">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h3 class="text-lg font-semibold text-slate-900 mb-2">确定要删除吗？</h3>
          <p class="text-sm text-slate-500 mb-6">将删除规则 "{{ deleteTarget?.ruleName }}"，删除后无法恢复。</p>
          <div class="flex items-center justify-center gap-3">
            <button class="btn-secondary" @click="closeDeleteModal">取消</button>
            <button class="btn-danger-secondary" @click="confirmDelete">确定删除</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 分账规则表单弹窗 -->
    <CommissionRuleForm
      :model-value="ruleFormVisible"
      :edit-id="ruleFormEditId"
      @update:model-value="ruleFormVisible = $event"
      @success="fetchRules"
    />
  </ListPageShell>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import AppPagination from '@/components/AppPagination.vue'
import ListPageShell from '@/components/ListPageShell.vue'
import PageFilterBar from '@/components/PageFilterBar.vue'
import {
  getCommissionRulePage, deleteCommissionRule,
  updateCommissionRulePriority
} from '@/api/commission'
import CommissionRuleForm from './CommissionRuleForm.vue'

// 分账规则表单弹窗状态
const ruleFormVisible = ref(false)
const ruleFormEditId = ref(null)

// 规则类型
const ruleTypes = [
  { value: 'GLOBAL', label: '全局规则' },
  { value: 'FRANCHISEE', label: '加盟商规则' },
  { value: 'PRODUCT', label: '产品规则' }
]

const searchForm = reactive({ ruleType: '', status: '' })
const loading = ref(false)
const ruleList = ref([])
const pagination = reactive({ current: 1, size: 20, total: 0, pages: 0 })
const showDeleteModal = ref(false)
const deleteTarget = ref(null)

const getTypeLabel = (type) => {
  const found = ruleTypes.find(t => t.value === type)
  return found ? found.label : type
}

const fetchRules = async () => {
  loading.value = true
  try {
    const params = {
      ruleType: searchForm.ruleType || undefined,
      status: searchForm.status !== '' ? Number(searchForm.status) : undefined,
      pageNum: pagination.current,
      pageSize: pagination.size
    }
    const res = await getCommissionRulePage(params)
    const data = res.data || res
    ruleList.value = data.records || []
    pagination.current = data.current
    pagination.size = data.size
    pagination.total = data.total
    pagination.pages = data.pages
  } catch (error) {
    ElMessage.error(error.message || '获取规则列表失败')
  } finally {
    loading.value = false
  }
}

const handleSearch = () => { pagination.current = 1; fetchRules() }
const resetSearch = () => { searchForm.ruleType = ''; searchForm.status = ''; pagination.current = 1; fetchRules() }
const handlePageChange = (page) => { if (page < 1 || page > pagination.pages) return; pagination.current = page; fetchRules() }
const handlePageSizeChange = (size) => { pagination.size = size; pagination.current = 1; fetchRules() }
const goToCreate = () => { ruleFormEditId.value = null; ruleFormVisible.value = true }
const goToEdit = (rule) => { ruleFormEditId.value = rule.id; ruleFormVisible.value = true }

const deleteRule = (rule) => { deleteTarget.value = rule; showDeleteModal.value = true }
const closeDeleteModal = () => { showDeleteModal.value = false; deleteTarget.value = null }

const confirmDelete = async () => {
  if (!deleteTarget.value) return
  try {
    await deleteCommissionRule(deleteTarget.value.id)
    ElMessage.success('删除成功')
    fetchRules()
  } catch (error) {
    ElMessage.error(error.message || '删除失败')
  } finally {
    closeDeleteModal()
  }
}

const changePriority = async (rule, delta) => {
  try {
    await updateCommissionRulePriority(rule.id, rule.priority + delta)
    fetchRules()
  } catch (error) {
    ElMessage.error(error.message || '更新优先级失败')
  }
}

onMounted(() => {
  fetchRules()
})
</script>
